@let origin = originSg();
@let outcome = outcomeSg();

<atn-summit-allocation-graph-base-overlay [origin]="origin">
  <h4 class="atn-summit-allocation-graph-outcome-overlay__name">
    {{ outcome.name }}
  </h4>
  @if (outcome.description) {
    <p class="atn-summit-allocation-graph-outcome-overlay__description">
      {{ outcome.description }}
    </p>
  }
</atn-summit-allocation-graph-base-overlay>
